export const buildAddress = (location) => {
  return `${location.name}. ${location.city.name} - ${location.city.country.name}`;
};
